module.exports = __webpack_public_path__ + "img/almondz-logo (1).31d3ebbc.png";